import React, { useContext, useEffect, useState } from "react";
import "./Default.scss";
import MenuHeader from "./menuHeader/MenuHeader";
import Loading from "@components/loading/Loading";
import { ToastContainer } from "react-toastify";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";
import { useNavigate } from "react-router-dom";
import IconSubirScroll from "@icons/IconSubirScroll";
import MenuLateral from "./menuLateral/MenuLateral";

const Default = (props) => {
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  // Função para verificar a posição do scroll
  const checkScrollPosition = () => {
    if (window.scrollY > window.innerHeight / 2) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  // UseEffect para adicionar o listener de scroll
  useEffect(() => {
    window.addEventListener("scroll", checkScrollPosition);

    // Limpeza do evento ao desmontar o componente
    return () => {
      window.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);

  return (
    <>
      <div className="default container">
        <MenuLateral />
        <MenuHeader
          nome={state.dadosusuario?.Nome_Usuario}
          app={props.app}
          ultimoAcesso={UtilServices.convertDataHora(
            state.dadosusuario?.Dt_Ultimo_Login,
          )}
        />
      </div>
      {props.back && (
        <div
          onClick={() => {
            navigate(-1);
          }}
          className={`${
            props.container === "fluid" ? "container-fluid" : "container"
          } `}
        >
          <i
            style={{
              fontSize: "24px",
              cursor: "pointer",
              marginTop: "40px",
              color: "var(--color-006)",
            }}
            className="fa-solid fa-backward-step"
          />
        </div>
      )}
      <div
        className={`default-icon ${
          props.container === "fluid" ? "container-fluid" : "container"
        } `}
      >
        {props.icon}
        <p>{props.title}</p>
      </div>
      <div
        className={`default-b ${
          props.container === "fluid" ? "container-fluid" : "container"
        }`}
      >
        {props.children}
      </div>
      <Loading type="spin" show={state.loading} color="#c1abff" />
      <ToastContainer />
      {showButton && (
        <div style={{ position: "fixed", bottom: "20px", right: "10px" }}>
          <IconSubirScroll
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </div>
      )}
    </>
  );
};

export default Default;
